/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// 渋谷店在庫バッジ：バリアント切り替え時に更新
document.addEventListener('variant:changed', function(e) {
  const variant = e.detail.variant;
  if (!variant) return;
  document.querySelectorAll('.shibuya-availability[data-product-id]').forEach(function(container) {
    // Set商品は常時表示のため更新不要
    if (container.dataset.isSet === 'true') return;
    const productId = container.dataset.productId;
    const dataScript = document.getElementById('shibuya-stock-data-' + productId);
    if (!dataScript) return;
    const stockData = JSON.parse(dataScript.textContent);
    const variantData = stockData[variant.id];
    const badge = container.querySelector('.shibuya-availability__badge');
    const label = badge ? badge.querySelector('.shibuya-availability__label') : null;
    if (!badge || !label) return;

    // stock が null / undefined / false はすべて「なし」
    if (!variantData || !variantData.stock) {
      label.textContent = '渋谷店在庫 : なし';
      badge.className = 'shibuya-availability__badge shibuya-availability__badge--out-of-stock';
      return;
    }

    // in_stock時: 優先順位に従いバッジ文言を決定
    const now = Math.floor(Date.now() / 1000);
    const productComingSoon = container.dataset.productComingSoon === 'true';
    const productSaleStart = parseInt(container.dataset.productSaleStart) || 0;

    const isComingSoon = variantData.coming_soon || productComingSoon;

    // バリアントにsale_start_timeがあればそちら優先、なければ商品レベルを使用
    const effectiveSaleStart = variantData.sale_start_time > 0
      ? variantData.sale_start_time
      : productSaleStart;
    const isSaleStarted = effectiveSaleStart === 0 || now >= effectiveSaleStart;

    const productPresell = parseInt(container.dataset.productPresell) || 0;
    const effectivePresell = variantData.presell > 0 ? variantData.presell : productPresell;
    const isPresell = effectivePresell > 0 && now >= effectivePresell;

    if (!isComingSoon && isSaleStarted) {
      label.textContent = '渋谷店在庫 : あり';
      badge.className = 'shibuya-availability__badge shibuya-availability__badge--in-stock';
    } else if (isPresell) {
      label.textContent = '渋谷店在庫 : あり (先行販売中)';
      badge.className = 'shibuya-availability__badge shibuya-availability__badge--presell';
    } else {
      label.textContent = '渋谷店在庫 : あり (発売前)';
      badge.className = 'shibuya-availability__badge shibuya-availability__badge--presale';
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  /* ターゲット選定の修正
   商品カード全体ではなく「中身」を動かすことで枠線消失を防ぐ
  */

  // 基本ターゲット
  let targetSelectors = '.promo-block, .article-item, .section__header, .featured-collection__image-wrapper, .image-with-text';

  // トップページの場合の追加ターゲット
  if (document.body.classList.contains('template-index')) {
    // .product-item（カード全体）ではなく、その中身を指定
    targetSelectors += ', .product-item__image-wrapper, .product-item__info';
  }

  const targets = document.querySelectorAll(targetSelectors);

  targets.forEach(target => {
    target.classList.add('reveal-on-scroll');
    observer.observe(target);
  });
});


/**
 * ▼▼▼ URLコピー機能（修正・完全版） ▼▼▼
 */
document.addEventListener('DOMContentLoaded', function () {

  // 1. 言語の判定（HTMLタグのlang属性、またはURLのロケールパスから判定）
  // 注意: pathname.indexOf('/ja') だと /products/japan-... 等の商品ハンドルにも
  // 誤マッチし、英語ストアで日本語と誤判定されるため、先頭ロケールのみを厳密判定する。
  var htmlLang = (document.documentElement.lang || '').toLowerCase(); // <html lang="ja"> を取得
  var path = window.location.pathname;
  var isJapanese = htmlLang.indexOf('ja') === 0 || path === '/ja' || path.indexOf('/ja/') === 0;

  var copiedMessage = isJapanese ? "コピーしました" : "Copied!";

  // ページ全体でのクリック監視（バリアント切り替え対応）
  document.addEventListener('click', function (e) {

    // クリックされた要素が .js-copy-link またはその内部か確認
    var link = e.target.closest('.js-copy-link');

    // コピーボタン以外がクリックされたら何もしない（ここで処理終了）
    if (!link) return;

    // ここからコピー処理実行
    e.preventDefault(); // リンク遷移を無効化

    // 最低限のURLを構築 (ドメイン + パスのみ)
    var cleanUrl = window.location.origin + window.location.pathname;

    // クリップボードへコピー処理
    if (navigator.clipboard) {
      navigator.clipboard.writeText(cleanUrl)
        .then(function () {
          showFeedback(link, copiedMessage);

        })
        .catch(function (err) {
          console.error('Copy failed: ', err);
          // 失敗してもフォールバック処理へ
          fallbackCopyTextToClipboard(cleanUrl, link, copiedMessage);
        });
    } else {
      // 古いブラウザ用フォールバック
      fallbackCopyTextToClipboard(cleanUrl, link, copiedMessage);
    }
  });

  // フォールバック用コピー関数
  function fallbackCopyTextToClipboard(text, linkElement, message) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // 画面外に配置
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
      showFeedback(linkElement, message);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
  }

  // メッセージ表示関数
  function showFeedback(linkElement, message) {
    if (!linkElement) return;

    // 元のテキストを保存（まだ保存されていなければ）
    var originalText = linkElement.getAttribute('aria-label');

    if (!linkElement.hasAttribute('data-original-text')) {
      linkElement.setAttribute('data-original-text', originalText || '');
    }

    // ツールチップ用属性(data-tooltip)と読み上げ用(aria-label)の両方にメッセージをセット
    linkElement.setAttribute('data-tooltip', message);
    linkElement.setAttribute('aria-label', message);

    // CSSで表示制御するためのクラスを付与
    linkElement.classList.add('is-active');

    // 2秒後に元に戻す
    setTimeout(function () {
      // 元のテキストに戻す
      var savedText = linkElement.getAttribute('data-original-text');

      // data-tooltipは削除
      linkElement.removeAttribute('data-tooltip');

      // aria-labelは元の文言に戻す
      if (savedText) {
        linkElement.setAttribute('aria-label', savedText);
      }

      linkElement.classList.remove('is-active');
    }, 2000);
  }

  /**
   * 購入制限(max属性)のバリデーション
   */
  document.addEventListener('change', function (e) {
    if (e.target.matches('.quantity-selector__value')) {
      const input = e.target;
      const max = parseInt(input.getAttribute('max'));
      const value = parseInt(input.value);

      if (max > 0 && value > max) {
        input.value = max;

      }
    }
  }, true);

  // 増減ボタンのクリック時にもバリデーションを行う（テーマのJS実行前に割り込む）
  document.addEventListener('click', function (e) {
    const button = e.target.closest('.quantity-selector__button');
    if (!button) return;

    const action = button.getAttribute('data-action');
    if (action === 'increase-quantity' || action === 'increase-picker-quantity') {
      const container = button.closest('.quantity-selector') || button.closest('quantity-picker');
      const input = container.querySelector('.quantity-selector__value');
      if (input) {
        const max = parseInt(input.getAttribute('max'));
        const currentValue = parseInt(input.value);
        if (max > 0 && currentValue >= max) {
          e.preventDefault();
          e.stopImmediatePropagation();

        }
      }
    }
  }, true);
});

/* ------------------------------------------------------------------------
 * 検索結果から 'hide' タグ付き商品を除外する
 *
 * Shopify の検索は、フィールド指定のない語（クラウン）に否定条件（-tag:hide）が付くと
 * 語が AND 条件にならず「hide 以外のほぼ全商品」を返す
 * （"クラウン -tag:hide" → 771件 / 存在しない語でも 748件。2026-10-08 本番で実測）。
 * 一方、語をダブルクォートで囲んだフレーズ指定は -tag:hide と正しく AND される
 * （"クラウン" -tag:hide → 17件）。このため日本語ストアでは語ごとにクォートしてから付加する。
 *
 * - ⚠️ クォートするのは日本語ストア（<html lang="ja">）だけ。英語ストアは翻訳文を検索するが、
 *   クォート指定は主言語（日本語）のインデックスにしか効かず "looping" "set" -tag:hide が
 *   1件になる（実測。クォートなしは Metal / Looping Set などが先頭に出る）。
 * - ⚠️ 英語ストアではクエリを一切変えない（-tag:hide も付けない）。付けると語が AND にならず
 *   Krown が 915件になる（付けなければ 44件）。hide は sections/main-search.liquid の
 *   「liquid モード」のループが除く（→ 9件。2026-10-09 実測）。URL も q=Krown のまま。
 *   日本語ストアの「近い候補」（relaxed=1）も同じ理由で -tag:hide を付けない。
 *   旧仕様の URL（Krown -tag:hide）は下のリダイレクトが 1 回で q=Krown に直す。
 * - 語は空白（全角含む）で分割し、各語をクォート。複数語は AND（暗黙）。
 *   ⚠️ ' AND ' で連結しないこと。main-search.liquid が ' AND ' の後ろだけを
 *   見出しに出す実装なので、2語目以降しか表示されなくなる。
 * - 利用者が構文を書いた入力（"" : ( ) * 先頭の - AND/OR/NOT）は語に触らず、
 *   末尾に -tag:hide を付けるだけ（フィールド指定の語は元から正しく AND される）。
 *   ただし閉じ忘れの " ( と、区切りの単独 - は先に取り除く（残すと -tag:hide が
 *   フレーズに飲まれて 1000件になる）。
 * - SKU（ハイフン区切りが 2つ以上の英数字。lead-aetheris-blue）は variants.sku:"..." に変換する。
 *   フレーズ指定では当たらないため。完全一致のみ（部分一致 lead-aetheris は 0件。0件画面の
 *   「近い候補」で救済）。英語ストアは素の語のままで SKU に当たる（c3-krown-blue → 1件）ので変換しない。
 * - ⚠️ OR / 括弧でクォート語を束ねる形は使えない。-tag:hide が最上位の OR に
 *   化けて 480〜888件に戻る（実測）。
 * - 冪等: 変換済みのクエリを渡しても同じ結果になる（フィルタ操作後の URL など）。リダイレクトは
 *   「変換結果が今の q と違うとき」だけなので、ループしない。旧仕様の URL（クラウン -tag:hide）も 1 回で正規化される。
 * - URL は変換後のまま残す（history.replaceState で見た目だけ戻すと、絞り込み後に「戻る」したとき
 *   theme.js の popstate がその URL で再読込して hide 商品が再び混ざる。実測 17件 → 101件）。
 * - 既知の制約: クォートは完全一致のため、前方一致（クラウ）・ひらがな・綴り揺れ・空白入りタグ名
 *   （Beginner Sets）は 0件になる。0件のときは main-search.liquid の「近い候補を表示する」リンクが
 *   &relaxed=1 を付けて開き直し、クォートなし（従来動作）で検索する。
 *   タグは tag:"Beginner Sets" で検索できる。
 * - ヘッダーの検索を同じページでもう一度送信すると古い語が送られる不具合への対処:
 *   theme.js の _onFormSubmit も送信のたびに入力欄を hidden に複製して元の name を外すため、
 *   bfcache 復元後などフォームが残っていると、前回の hidden の q が送られる。
 *   送信のたびに前回の hidden の q を取り除き、見えている入力欄の name を戻してから処理する。
 * ------------------------------------------------------------------------ */
(function () {
  var HIDE_RE_ALL = /(^|\s)-tag:hide(?=\s|$)/g;
  var SYNTAX_RE = /["():*\\]|(^|\s)-\S|(^|\s)(AND|OR|NOT)(\s|$)/;
  var searchPath = ((window.routes && window.routes.searchUrl) || '/search').replace(/\/+$/, '');
  var quoteTerms = (document.documentElement.lang || '').toLowerCase().indexOf('ja') === 0;
  // SKU らしい語（ASCII で、区切りの - _ が 2つ以上かつ - を含む。例: lead-aetheris-blue / c3-krown-blue）。
  // 引用符フレーズでは SKU に当たらない（実測 0件）ため variants.sku:"..." で検索する。
  // yo-yo や bi-metal のような普通の語（区切り 1つ）は対象外。
  var SKU_RE = /^(?=[^-]*-)[A-Za-z0-9]+(?:[-_][A-Za-z0-9]+){2,}$/;

  function isSearchPath(path) {
    return path.replace(/\/+$/, '') === searchPath;
  }

  function count(str, ch) {
    return str.split(ch).length - 1;
  }

  // 1語を検索語にする。SKU らしければ variants.sku、それ以外はクォート
  function toTerm(w) {
    if (SKU_RE.test(w)) return 'variants.sku:"' + w + '"';
    return '"' + w + '"';
  }

  // 入力 → Shopify に渡すクエリ。
  // 英語ストアと relaxed（日本語ストアの「近い候補」）は語を変えず、-tag:hide も付けない
  // （hide は main-search.liquid が除く）。旧仕様の URL に残った -tag:hide はここで外れる。
  function toSearchQuery(raw, relaxed) {
    var q = String(raw).replace(HIDE_RE_ALL, ' ');
    if (!quoteTerms || relaxed) return q.replace(/\s+/g, ' ').trim();
    if (count(q, '"') % 2) q = q.replace(/"/g, ' ');
    if (count(q, '(') !== count(q, ')')) q = q.replace(/[()]/g, ' ');
    q = q.replace(/(^|\s)-(?=\s|$)/g, ' ').replace(/\s+/g, ' ').trim();
    if (!q) return '';
    if (!SYNTAX_RE.test(q)) {
      q = q.split(/\s+/).map(toTerm).join(' ');
    }
    return q + ' -tag:hide';
  }

  // 検索フォーム送信時。非表示inputを追加することで、検索バーの表示を変えずに変換後のクエリを送る
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || String(form.method).toLowerCase() !== 'get') return;
    var url;
    try { url = new URL(form.action, window.location.href); } catch (err) { return; }
    if (!isSearchPath(url.pathname)) return;
    // 利用者が入力する欄。前回の送信で name を外していても見つけられるよう印を付けておく
    // （theme.js の複製は属性ごと写すので、hidden は除いて探す）
    var qInput = form.querySelector('[data-search-q-input]:not([type="hidden"])') || form.querySelector('input[name="q"]:not([type="hidden"])');
    if (!qInput) return;
    qInput.setAttribute('data-search-q-input', '');
    // 前回の送信で残った hidden の q（このコード / theme.js の複製）を除き、入力欄の name を戻す
    Array.prototype.forEach.call(form.querySelectorAll('input[type="hidden"][name="q"]'), function (el) {
      el.parentNode.removeChild(el);
    });
    qInput.setAttribute('name', 'q');
    var searchQ = toSearchQuery(qInput.value);
    if (!searchQ || searchQ === qInput.value.trim()) return;
    var hiddenQ = document.createElement('input');
    hiddenQ.type = 'hidden';
    hiddenQ.name = 'q';
    hiddenQ.value = searchQ;
    form.appendChild(hiddenQ);
    qInput.removeAttribute('name');
  }, true);

  // /search を直接開いたとき。変換結果が今の q と違うときだけ 1 回リダイレクトする
  if (isSearchPath(window.location.pathname)) {
    var params = new URLSearchParams(window.location.search);
    var q = params.get('q');
    var searchQ = q ? toSearchQuery(q, params.get('relaxed') === '1') : '';
    if (searchQ && searchQ !== q.trim()) {
      params.set('q', searchQ);
      window.location.replace(window.location.pathname + '?' + params.toString());
    }
  }
})();

/**
 * ▼▼▼ Instagram埋め込みの安定化 ▼▼▼
 *
 * Instagram公式の embed.js はページ読み込み時に一度だけ blockquote を iframe へ変換する。
 * バリアント切替などでテーマがセクションを再描画すると blockquote が元に戻り、
 * 再処理されないため埋め込みが空白になる。未処理の blockquote を検知して再処理する。
 *
 * 注意: リール／動画はInstagram側の非ログイン制限で再生が止まる場合があり、
 *       それはこのコードでは制御できない（確実に見せたい場合は動画をShopifyへ直接アップロード）。
 */
(function () {
  var EMBED_SRC = 'https://www.instagram.com/embed.js';
  var reprocessTimer;

  function hasInstagramEmbed() {
    return !!document.querySelector('.instagram-media');
  }

  function loadEmbedScript() {
    return new Promise(function (resolve) {
      if (window.instgrm && window.instgrm.Embeds) return resolve();
      if (document.getElementById('instagram-embed-js')) return resolve();
      var s = document.createElement('script');
      s.id = 'instagram-embed-js';
      s.async = true;
      s.src = EMBED_SRC;
      s.onload = resolve;
      s.onerror = resolve;
      document.body.appendChild(s);
    });
  }

  function processEmbeds() {
    if (!hasInstagramEmbed()) return;
    loadEmbedScript().then(function () {
      if (window.instgrm && window.instgrm.Embeds) {
        // process() は処理済みの blockquote はスキップするため何度呼んでも安全
        window.instgrm.Embeds.process();
      }
    });
  }

  function scheduleReprocess() {
    clearTimeout(reprocessTimer);
    // 再描画でDOMが差し替わった直後だと取りこぼすため少し待つ
    reprocessTimer = setTimeout(processEmbeds, 300);
  }

  function init() {
    processEmbeds();

    // バリアント切替などセクション再描画時
    document.addEventListener('variant:changed', scheduleReprocess);

    // 動的に挿入される blockquote を監視（タブ・スライダー・クイックビュー・再描画全般に対応）
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue; // 要素ノードのみ
          var isEmbed =
            (node.classList && node.classList.contains('instagram-media')) ||
            (node.querySelector && node.querySelector('.instagram-media'));
          if (isEmbed) {
            scheduleReprocess();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();



/* ------------------------------------------------------------------------
 * スクロールロック（html.is-locked）の取りこぼしを解除する
 *
 * ベーステーマ（Warehouse）は drawer / モーダル / ミニカート / 検索を開くと
 * <html> に is-locked（theme.css: overflow-y: hidden）を付ける。
 * 以下の2経路でこれが外れず、「見た目は完全に正常なのにスクロールだけ
 * 効かない」状態になる（2026-09-08 に本番 375px 幅で実測）。
 *
 *  1) ブラウザバック（bfcache 復元）
 *     theme.js:9554 の pageshow ハンドラは検索入力をクリアして検索 UI を
 *     閉じるが、is-locked には一切触れない。復元後は検索バーが
 *     visibility:hidden になるため、ロックされている手掛かりが何も残らない。
 *
 *  2) スマホで検索を「検索アイコン」から閉じたとき
 *     theme.js:9602 _onInputFocus が is-locked を付けるが、
 *     theme.js:9626 _onFocusOut は matchesBreakpoint('phone') で即 return
 *     する。解除するのは ✕ ボタン（[data-action="unfix-search"]）を押した
 *     ときだけなので、検索アイコンをもう一度押して閉じるとロックが残る。
 *
 * 加えて header の search_menu が未設定のため .search-bar__menu-wrapper が
 * 存在せず、空欄でフォーカスしても .search-bar.is-expanded が付かない
 * = 全画面パネルが出ない。このため「ロックだけかかって何も見えない」
 * という最悪の見え方になる。
 *
 * theme.js を直接直すとベーステーマ更新で消えるため、ここに置く。
 * 開いている overlay が1つでもあれば何もしない（正当なロックは残す）。
 * ---------------------------------------------------------------------- */
(function () {
  // aria-hidden="false" が「開いている」を意味するテーマ側の overlay 群。
  // .drawer は #mobile-collection-filters（コレクション/検索の絞り込み）のみ。
  var OVERLAY_SELECTOR = '#mobile-menu, .mini-cart, .modal, .drawer, .value-picker';

  function anyOverlayOpen() {
    var nodes = document.querySelectorAll(OVERLAY_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('aria-hidden') === 'false') return true;
    }
    // 検索バーだけは aria-hidden ではなくクラスで状態を持つ。
    // is-fixed（全画面化）だけでは visibility:hidden で見えないので、
    // is-visible と両方揃っているときだけ「開いている」とみなす。
    var searchWrapper = document.querySelector('.header__search-bar-wrapper');
    if (
      searchWrapper &&
      searchWrapper.classList.contains('is-visible') &&
      searchWrapper.classList.contains('is-fixed')
    ) {
      return true;
    }
    return false;
  }

  function releaseStaleLock() {
    var html = document.documentElement;
    if (!html.classList.contains('is-locked')) return;
    if (anyOverlayOpen()) return;

    html.classList.remove('is-locked');

    // 取り残された全画面ラッパー（position:fixed / height:100vh）も畳む。
    // visibility:hidden なのでタップは透過するが、残す理由がない。
    var searchWrapper = document.querySelector('.header__search-bar-wrapper');
    if (searchWrapper) searchWrapper.classList.remove('is-fixed');
  }

  // (1) bfcache 復元。theme.js 側の pageshow ハンドラが同じ dispatch 内で
  //     同期的に検索 UI を閉じるため、判定は次のタスクへ回して最後に走らせる。
  //     aria-hidden が transition 後に変わる overlay もあるので再度確認する。
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    setTimeout(releaseStaleLock, 0);
    setTimeout(releaseStaleLock, 400);
  });

  // (2) 検索バーの開閉を監視し、閉じられた時点で取り残しを解除する。
  //     クラス変更直後は theme.js の処理が続いていることがあるため遅延させる。
  function watchSearchBar() {
    var searchWrapper = document.querySelector('.header__search-bar-wrapper');
    if (!searchWrapper) return;

    new MutationObserver(function () {
      setTimeout(releaseStaleLock, 0);
    }).observe(searchWrapper, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchSearchBar);
  } else {
    watchSearchBar();
  }
})();

/* ============================================================
 * よくある質問ページ（/pages/faq）：キーワード検索と、#faq-xxx で質問を開く処理
 * 本文は Page/faq/faq.html。.rw-faq がないページでは何もしない。
 * ============================================================ */
(function () {
  var root = document.querySelector('.rw-faq');
  if (!root || root.dataset.init) return;
  root.dataset.init = '1';

  var items = Array.prototype.slice.call(root.querySelectorAll('.rw-faq__item'));
  var groups = root.querySelectorAll('.rw-faq__group');
  var input = document.getElementById('rw-faq-search');
  var clear = document.getElementById('rw-faq-clear');
  var count = document.getElementById('rw-faq-count');
  var empty = document.getElementById('rw-faq-empty');
  // 件数の文言は本文の data-count-text で言語ごとに渡す（{n} が件数）。英語版の翻訳本文で使う
  var countText = root.dataset.countText || '{n}件見つかりました';

  // 全角半角・大文字小文字・カタカナひらがなの違いを無視して比べる
  // 英語は iPhone のスマート句読点（’）や本文のダッシュ（–）も普通の記号として比べる
  function norm(s) {
    return (s || '').normalize('NFKC').toLowerCase()
      .replace(/[‘’‚‛]/g, "'")
      .replace(/[‐-―−]/g, '-')
      .replace(/[ァ-ヶ]/g, function (c) {
        return String.fromCharCode(c.charCodeAt(0) - 0x60);
      });
  }
  var texts = items.map(function (item) {
    return norm(item.textContent + ' ' + (item.dataset.keywords || ''));
  });

  // キーワード検索：空白区切りの語をすべて含む質問だけ表示して開く
  function filter() {
    var words = norm(input.value).trim().split(/\s+/).filter(Boolean);
    var hits = 0;
    items.forEach(function (item, i) {
      var match = words.every(function (w) { return texts[i].indexOf(w) !== -1; });
      item.hidden = !match;
      if (words.length) item.open = match; // 検索を消したときは開閉状態を変えない
      if (match) hits++;
    });
    groups.forEach(function (g) {
      g.hidden = !g.querySelector('.rw-faq__item:not([hidden])');
    });
    clear.hidden = !words.length;
    empty.hidden = hits !== 0;
    count.textContent = words.length && hits ? countText.split('{n}').join(hits) : '';
  }
  function reset() {
    if (!input.value) return;
    input.value = '';
    filter();
  }

  // 日本語入力の変換中は絞り込まない
  var composing = false;
  input.addEventListener('compositionstart', function () { composing = true; });
  input.addEventListener('compositionend', function () { composing = false; filter(); });
  input.addEventListener('input', function (e) {
    if (!composing && !e.isComposing) filter();
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') reset();
  });
  clear.addEventListener('click', function () {
    reset();
    input.focus();
  });

  // URLの #faq-xxx で指定されたカテゴリ・質問を表示する（質問なら開く）
  function openFromHash() {
    var id = decodeURIComponent(location.hash.slice(1));
    var target = id && document.getElementById(id);
    if (!target || !root.contains(target)) return;
    reset();
    if (target.classList.contains('rw-faq__item')) target.open = true;
    // テーマが html に scroll-behavior: smooth を指定しているので、読み込み時は即座に移動する
    target.scrollIntoView({ block: 'start', behavior: 'instant' });
  }
  openFromHash();
  window.addEventListener('load', openFromHash); // 画像やヘッダーの読み込みで位置がずれるため
  window.addEventListener('hashchange', openFromHash);

  // テーマの theme.js は # リンクのクリックを横取りしてハッシュを変えないため、
  // ページ内リンクはテーマに渡さずブラウザ標準の移動にする
  root.addEventListener('click', function (e) {
    if (e.target.closest('a[href^="#faq-"]')) {
      e.stopPropagation();
      reset();
    }
  });

  // 利用者が質問を開いたらURLをその質問のものにする（問い合わせ対応でリンクを送れるように）。
  // toggle イベントは検索で開閉したときにも遅れて届くため、質問文のクリックで判定する
  items.forEach(function (item) {
    item.querySelector('summary').addEventListener('click', function () {
      setTimeout(function () {
        if (item.open && !input.value && history.replaceState) {
          history.replaceState(null, '', '#' + item.id);
        }
      }, 0);
    });
  });
})();

/*
 * 商品カードのカラー（バリアント画像サムネイル）の「+N」を、一覧の幅が変わったら数え直す。
 * テーマ（theme.js の recalculateSwatches）は初期化時と window の resize でしか数えないが、
 * 初期化の後にスクロールバーやサイドバーの表示で一覧の幅が変わることがあり（例：200px → 172px）、
 * そのままだと最後のサムネイルや「+N」が右端で切れる。幅の変化を見て resize を出し、テーマに数え直させる。
 * （rewind-filter.js がカードを差し替えた後に resize を出しているのと同じ方法）
 */
(function () {
  if (!('ResizeObserver' in window)) return;

  var lastWidth = 0;
  var timer;

  var observer = new ResizeObserver(function (entries) {
    var width = Math.round(entries[0].contentRect.width);
    if (width === lastWidth) return;

    lastWidth = width;
    clearTimeout(timer);
    timer = setTimeout(function () {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  });

  document.addEventListener('DOMContentLoaded', function () {
    var swatchList = document.querySelector('.product-item__swatch-list');
    if (swatchList) observer.observe(swatchList);
  });
})();

/*
 * 商品カードのカラー（バリアント画像サムネイル）で色を選んだら、そのカードだけホバー時の2枚目の画像を止める。
 * テーマのホバー（.product-item__image-wrapper--with-secondary）は選んだ色の画像を2枚目の写真で隠してしまう。
 * 色を選ぶまではホバーで2枚目を見られるよう、クラスは選んだ時点で外す。
 * 画像の差し替え自体はテーマ（theme.js の _colorChanged）が行う。
 */
document.addEventListener('change', function (event) {
  var radio = event.target;
  if (!radio.matches || !radio.matches('.product-item__swatch-list .color-swatch__radio')) return;

  var wrapper = radio.closest('.product-item');
  wrapper = wrapper && wrapper.querySelector('.product-item__image-wrapper--with-secondary');
  if (wrapper) wrapper.classList.remove('product-item__image-wrapper--with-secondary');
});

/*
 * テーマが対応していないセクションの商品カードでも、カラーのサムネイルを動かす。
 * テーマ（theme.js の ProductItemColorSwatch）は、下の THEME_HANDLED のセクションにしか
 * 「クリックで画像を切り替える処理」と「+N の計算」を付けない。そのため、トップページの
 * collection-tabs（独自セクション）などではサムネイルを押しても何も起きなかった。
 * それ以外のセクションのカードにだけ、テーマと同じ動きをここで付ける。
 */
(function () {
  var THEME_HANDLED = ['collection', 'featured-collection', 'product-recommendations', 'recently-viewed-products'];

  function isHandledByTheme(element) {
    var section = element.closest('[data-section-type]');
    return !!section && THEME_HANDLED.indexOf(section.getAttribute('data-section-type')) !== -1;
  }

  // 「+N」：theme.js の recalculateSwatches と同じ計算（1個 30px、幅は最大 200px まで使う）
  function recalculate(swatchList) {
    var maxFit = Math.floor(Math.min(swatchList.clientWidth, 200) / 30);
    var swatches = swatchList.querySelectorAll('.color-swatch');

    for (var i = 0; i < swatches.length; i++) {
      swatches[i].classList.toggle('color-swatch--view-more', maxFit === i + 1 && maxFit !== swatches.length);
    }
  }

  // タブで隠れている一覧は幅 0 なので、表示されて幅が変わったときに数え直す
  var observer = 'ResizeObserver' in window
    ? new ResizeObserver(function (entries) {
        entries.forEach(function (entry) { recalculate(entry.target); });
      })
    : null;

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-item__swatch-list').forEach(function (swatchList) {
      if (isHandledByTheme(swatchList)) return;

      if (observer) {
        observer.observe(swatchList);
      } else {
        recalculate(swatchList);
      }
    });
  });

  // クリックで画像とリンク先をその色に切り替える（theme.js の _colorChanged と同じ動き）
  document.addEventListener('change', function (event) {
    var radio = event.target;
    if (!radio.matches || !radio.matches('.product-item__swatch-list .color-swatch__radio')) return;
    if (isHandledByTheme(radio)) return;

    var productItem = radio.closest('.product-item');
    if (!productItem) return;

    var variantUrl = radio.getAttribute('data-variant-url');
    if (variantUrl) {
      productItem.querySelectorAll('.product-item__image-wrapper, .product-item__title').forEach(function (link) {
        link.setAttribute('href', variantUrl);
      });
    }

    var image = productItem.querySelector('.product-item__primary-image');
    var imageUrl = radio.getAttribute('data-image-url');
    var mediaId = radio.getAttribute('data-media-id');

    if (image && imageUrl && image.getAttribute('data-media-id') !== mediaId) {
      // srcset が残ると元の画像が優先されるので外す
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.setAttribute('src', imageUrl);
      image.setAttribute('data-media-id', mediaId);
    }
  });
})();
